// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
}

body::ng-deep {
  overflow-y: hidden !important;
}

.chat-header {
  height: 50px;
}

.chat-header,
.chat-content {
  width: 90%;
  display: flex;
  justify-content: space-evenly;
}

.wrapper {
  display: flex;
  height: 100%;
  flex-direction: row;
  justify-content: stretch;
}

.chat-sidebar {
  max-width: 320px;
  height: 100%;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 0px 2.6px;
}

.chatBotstyle {
  display: flex;
  flex-direction: row;
  width: 100% !important;
  height: 100%;
}

.hide {
  display: none;
}

.fa {
  cursor: pointer;
}

.chat-box-wrapper {
  position: relative;
  display: flexbox;
  width: 90%;
}

.chat-left-content {
  background: #fff;
  min-width: 280px;
  overflow-y: auto;
  /* box-shadow:2px 0px 0px rgba(0, 0, 0, 0.21); */
  /* box-shadow:3px 0px #e9e9e9; */
}

.chat-right-content {
  /* margin-left:20px; */
  /* width: clamp(300px,150vw,70vw); */
  min-width: 70%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  justify-content: space-evenly;
}

#title {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-evenly;
  margin: 10px 0px;
  font-size: 16px;
  font-weight: bold;
}

.chat-history-list {
  height: 80vh;
  overflow-y: auto;
}

.chat-history-list ul {
  margin: 10px 0px;
  padding: 0px 10px;
  list-style: none;
  display: flex;
  flex-direction: column;
  line-height: 1.2rem;
}
.chat-history-list ul li {
  display: inline-flex;
  justify-content: space-evenly;
  align-items: baseline;
}
.chat-history-list ul li label:first-child {
  display: inline-block;
  background: #eee;
  color: #666;
  border-radius: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  font-size: 0.9rem;
  min-height: 25px;
  padding: 10px 10px;
  margin-bottom: 10px;
  width: 90%;
}
.chat-history-list ul li label:last-child {
  margin: 0% 3%;
  display: inline-block;
  width: 5%;
  padding-left: 2%;
}

#chat-list-content {
  position: fixed;
  /* bottom:90px; */
  /* width:clamp(300px,198vw,68vw); */
  margin-top: 75px;
  width: 60%;
  padding: 0% 2%;
  /* overflow-y: auto;
    height: 100vh;
    top: 70px; */
  font-size: 0.9rem !important;
  /*  display: flex;
    justify-content: space-evenly; */
}

#chat-list {
  position: relative;
  overflow-y: auto;
  width: 95%;
  height: 80vh;
  padding-right: 5px;
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

#chat-list::-webkit-scrollbar {
  display: none;
}

.chat-list-row {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  padding: 0px 0px;
  /* .menu-list{
     display: none;
   }


   &:hover,&:focus{
     .menu-list{
        display: block;
     }
   } */
}
.chat-list-row .date-label {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 30px;
  color: var(--textsecondarycolor) !important;
}

#chat-message-enter-box {
  /* position: fixed; */
  background: #fff;
  width: 60%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;
  height: 51px;
  z-index: 1;
  /* top:65px; */
}
#chat-message-enter-box form {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
}
#chat-message-enter-box textarea {
  width: 100% !important;
  border: none;
  padding: 10px;
  color: #666;
  font-size: 1em;
  resize: none;
  height: 55px;
}
#chat-message-enter-box span {
  display: inline-block;
  color: #666;
  width: 100% !important;
  padding: 10px;
  color: #666;
  font-size: 1em;
  min-height: 55px;
}

/* .chat-header > span{
    display: inline-block;
        color: #666;
        width: 90% !important;
        padding: 10px;
        color: #666;
        font-size:1em;
        min-height:100px;
} */
.fa-cloud,
.fa-user-circle {
  color: #9da0a3;
  margin-top: 5px;
  font-size: 30px !important;
}

app-toggle-icon::ng-deep .fa-microphone-slash,
.fa-microphone-slash {
  opacity: 0.5 !important;
}

textarea::placeholder {
  color: rgb(182, 182, 182) !important;
}

.question.loading {
  display: flex;
  gap: 10px;
}

.question {
  width: 100%;
  /* background: #9da0a3;   */
  /* background: #01488f; */
  background-color: #f0f2f5;
  border-radius: 8px;
  padding: 12px 16px;
  min-height: 50px;
  font-size: 1rem;
  padding: 15px 10px;
  color: var(--textprimarycolor);
  font-weight: bold;
  margin-bottom: 1px;
  position: relative;
  display: flex;
  align-items: center;
  /* box-shadow: 2px 2px 3px #000; */
  /* box-shadow: rgba(25, 118, 210, 0.35) 0px 5px 15px; */
  /* box-shadow: rgba(109, 129, 153, 0.35) 0px 5px 15px; */
}

/* .question::before{
    content: " ";
    position: absolute;
    width: 0;
    height: 0;
    left:-15px;
    right:auto;
    top:10px;
    bottom: auto;
    border:15px solid;
    border-color:var(--primaryColor) transparent transparent transparent;




} */
.question.align-right {
  /* background: #f2fcff; */
  background: #9da0a3;
  min-height: 50px;
  border-radius: 5px;
  padding: 10px;
  color: #fff;
  margin-bottom: 10px;
  width: 100%;
  margin-left: 50%;
  margin-right: 15px;
  position: relative;
}

.question.align-right::before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: -20px;
  top: 0px;
  bottom: auto;
  border: 21px solid;
  border-color: #848a92 transparent transparent transparent;
}

video {
  margin: 10px 0px;
}

.answer {
  background-color: #f8f8f8;
  border-radius: 0px 24px 0px 24px;
  min-height: 50px;
  padding: 0px 10px 10px;
  color: var(--textsecondarycolor) !important;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 0.2rem;
  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */
}
.answer .button {
  background: transparent !important;
  box-shadow: none !important;
  border: none;
}

.source-label {
  font-size: 0.95rem;
  text-align: right;
}

.document-file-input label {
  margin-right: 10px;
}
.document-file-input input[type=text] {
  height: 2rem;
  border: 1px solid #ccc;
}
.document-file-input input[type=text]::placeholder {
  padding-left: 2px;
}

.answer-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-right: 10px;
  gap: 15px;
  min-height: 30px;
  position: sticky;
  right: 0px;
  top: 0px;
  bottom: 10px;
  z-index: 9;
  margin-bottom: 15px;
}
.answer-header span {
  font-weight: bold;
}
.answer-header .fa-thumb-tack.active {
  color: var(--buttonbackgroundcolor) !important;
}

.audio {
  cursor: pointer;
}

ul li {
  display: inline;
  list-style: none;
  margin: 5px 10px;
  display: inline-block;
  cursor: pointer;
}

.menu-list {
  position: relative;
}
.menu-list ul {
  position: absolute;
  top: 2px;
  right: -15px;
  width: max-content;
  background: #fff !important;
  border: 1px solid #dcdcdc !important;
  border-radius: 1rem !important;
}
.menu-list ul li {
  margin: 6px 10px;
  display: inline-block;
  cursor: pointer;
}
.menu-list ul li:hover .fa {
  color: #008cb3;
}
.menu-list ul.active {
  display: block;
}
.menu-list label {
  width: 20px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.dropdown-menu {
  left: -55px !important;
}

.dropdown-item {
  padding: 0px !important;
}
.dropdown-item li {
  margin: 5px 0px !important;
  font-size: 12px !important;
  width: 100%;
  padding: 5px 10px;
}
.dropdown-item li:hover {
  background: var(--primarylightColor);
  color: var(--primaryColor);
}

/*.answer-content::before{
    content: " ";
    position: absolute;
    width: 0;
    height: 0;
    left:-25px;
    right:auto;
    top:-25px;
    bottom: auto;
    border: 21px solid;
    border-color: #fff transparent transparent transparent;


} */
.answer-content {
  position: relative;
  padding: 3px 5px;
  line-height: 1.6;
  font-size: 0.95rem;
}

.answer-content::ng-deep ul {
  margin-left: 2em;
  margin-top: 1em;
}

.answer-content ::ng-deep .answer-tags {
  text-align: justify;
  padding: 10px 20px;
}

.answer-content ::ng-deep pre {
  white-space: pre-wrap !important;
}

.answer-content::ng-deep ol {
  padding: 10px !important;
}

.feedback::before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -25px;
  right: auto;
  top: 0px;
  bottom: auto;
  border: 21px solid;
  border-color: #fff transparent transparent transparent;
}

.feedback {
  position: relative;
  color: #111;
}
.feedback ol {
  padding: 30px;
}

.chat-icon {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  background: var(--primarylightColor);
}
.chat-icon .bot-icon {
  margin-top: 5px;
}
.chat-icon img {
  border-radius: 100%;
}

.username {
  width: 36px;
  height: 36px;
  border-radius: 100%;
  background: var(--primarylightColor);
  color: var(--primaryColor);
  vertical-align: middle;
  text-align: center;
  font-size: 22px;
  margin-right: 5px;
  display: inline-block;
  text-transform: uppercase;
}

#chatForm {
  width: 100%;
  height: inherit;
}

#chatForm > span {
  width: 90%;
  height: inherit;
  margin-left: 10px;
}

#expand-collapse {
  position: relative;
  margin-top: 25px;
  height: 15px;
}
#expand-collapse i {
  background: #fff;
  padding: 10px;
}
#expand-collapse .fa {
  font-size: 1.5em !important;
  transform: rotate(180deg) translateX(0px);
  transform-origin: 50% 20%;
}

::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fff;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #fff;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #fff;
}

#chat-content-wrapper {
  display: flex;
  justify-content: space-around;
  width: 100%;
}
#chat-content-wrapper header {
  background: transparent !important;
  padding: 5px !important;
}

.chat-history-list::ng-deep .tabs-container {
  height: 80vh !important;
}
.chat-history-list::ng-deep .tabs-container ul {
  display: flex;
}
.chat-history-list::ng-deep .tabs-container li {
  width: 50%;
  font-size: 0.9em;
}
.chat-history-list::ng-deep .tabs-container app-tab .pane {
  padding: 0px !important;
}
.chat-history-list::ng-deep .tabs-container app-tab li {
  width: 100%;
}

#voice-message {
  width: 80% !important;
  position: relative;
  background: #fff;
  margin-top: -50px;
  margin-left: 10px;
  padding-right: 10px;
  height: 50px;
}
#voice-message span {
  display: inline-block;
  color: #999;
}

#chat-tools {
  display: flex;
  list-style-type: none;
  width: 60px;
  flex-direction: row;
  gap: 20px;
  padding: 0px;
  margin: 0px;
  position: relative;
  right: 10px;
}
#chat-tools .fa-paper-plane {
  font-size: 17px !important;
}

[hidden] {
  display: none !important;
}

.comment-area-box::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 1px;
  left: 99%;
  box-sizing: border-box;
  border: 10px solid rgba(0, 0, 0, 0.5);
  border-color: transparent transparent #fff #fff;
  transform-origin: 0 0;
  transform: rotate(135deg);
  box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.35);
}

.comment-area-box {
  display: none;
  background: #fff;
  padding: 15px 10px 5px;
  width: 80%;
}
.comment-area-box label {
  width: -moz-fit-content !important;
  width: fit-content !important;
}
.comment-area-box textarea {
  resize: none;
}
.comment-area-box .form-btns {
  width: 100%;
  display: flex;
  margin: 5px 0px;
}
.comment-area-box .form-btns .btn:first-child {
  border: 1px solid #dbdbdb;
  background: #fff !important;
  color: #000 !important;
}
.comment-area-box .form-btns .btn {
  --bs-btn-line-height: 1.2 !important;
  font-size: 0.9rem !important;
  padding: 5px 20px;
  color: #fff;
  background: var(--primaryColor);
  margin-right: 15px;
  border: none;
  cursor: pointer;
  font-family: "Noto Sans", sans-serif;
}

.comment-area-box.is-active {
  display: flex;
  margin-top: 10px;
  align-items: center;
}

.comment-form {
  margin-left: 10px;
  margin-top: 10px;
}
.comment-form label {
  font-size: 0.9rem;
}
.comment-form textarea {
  margin-right: 25px;
}
.comment-form .comments-field {
  margin-top: 10px;
}
.comment-form .comments-field .form-btns {
  float: right;
}
.comment-form .button:hover {
  background: var(--primaryColor) !important;
  color: #fff !important;
}
.comment-form .button:hover .fa, .comment-form .button:hover .fa-solid {
  color: #fff !important;
}
.comment-form .button.selected {
  background: var(--primaryColor) !important;
  color: #fff !important;
}
.comment-form .button.selected i {
  color: #fff !important;
}
.comment-form .sbtn {
  background: var(--primaryColor) !important;
  color: #fff !important;
}
.comment-form .form-btns .button.sbtn:first-child {
  background: #fff !important;
  color: var(--primaryColor) !important;
  border: 1px solid var(--primaryColor) !important;
  margin-right: 10px;
}
.comment-form .form-btns .button.sbtn:first-child:hover {
  background: #f5f5f5 !important;
}

.chat-icon:has(> .bot-icon) {
  position: sticky;
  top: 0;
  margin-bottom: 40px;
}

@media screen and (max-width: 640px) {
  #chat-list-content {
    width: 100% !important;
    padding: 0% 2% !important;
    margin-top: 60px;
  }
  #chat-message-enter-box {
    width: 100% !important;
  }
  .chat-list-row {
    width: 100%;
    padding: 0px 5px;
  }
  .question {
    padding: 12px 10px !important;
    font-size: 0.9rem !important;
    border-radius: 20px 4px 20px 20px;
    margin-bottom: 5px;
    min-height: auto;
  }
  .bot-search-text {
    font-size: 0.9rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .answer {
    padding: 10px 8px !important;
    border-radius: 0px 20px 0px 20px;
    margin-top: 0.1rem;
  }
  .answer-content {
    font-size: 0.85rem !important;
    padding: 3px 2px;
    line-height: 1.5;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .answer-header {
    justify-content: flex-end;
    padding-right: 5px;
    gap: 8px;
    min-height: 25px;
    margin-bottom: 10px;
  }
  .menu-list {
    margin-top: 5px;
  }
  .menu-list ul {
    right: -10px;
    padding: 5px;
    border-radius: 0.8rem;
  }
  .menu-list ul li {
    margin: 4px 6px;
    font-size: 0.9rem;
  }
  ul li {
    margin: 3px 5px;
  }
  .source-label {
    font-size: 0.85rem !important;
    text-align: left;
    padding: 5px 0;
  }
  .comment-form {
    margin-left: 5px;
    margin-top: 8px;
  }
  .comment-form .button {
    padding: 8px 12px;
    font-size: 0.85rem;
  }
  .comment-form textarea {
    width: 100% !important;
    margin-right: 0;
    font-size: 0.85rem;
    padding: 8px;
  }
  .comment-form .comments-field {
    margin-top: 8px;
  }
  .comment-form .comments-field .form-btns {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }
  .comment-form .comments-field .form-btns .button {
    width: 100%;
    margin: 0;
  }
  .date-label {
    font-size: 0.8rem;
    margin-bottom: 20px;
  }
  .question-text {
    font-size: 0.9rem !important;
    flex-direction: column;
    gap: 5px;
  }
  .modal-content {
    width: 95% !important;
    max-width: 95% !important;
    margin: 10px;
  }
  .modal-content .modal-body {
    height: calc(100vh - 250px);
    padding: 15px;
  }
  .modal-content .modal-footer {
    padding: 10px 15px;
  }
  .modal-content .modal-footer .row {
    flex-direction: column;
    gap: 10px;
  }
  .modal-content .modal-footer button[type=button] {
    width: 100%;
    margin: 5px 0;
    padding: 10px;
  }
  .modal-fullscreen .modal-content {
    width: 100% !important;
    height: 100vh;
    margin: 0;
    border-radius: 0;
  }
  .bot-loader-wrapper {
    width: 25px;
    height: 35px;
    margin-right: 15px;
  }
  .bot-loader-wrapper .ai-diamond {
    width: 20px;
    height: 20px;
    top: 6px;
    left: 6px;
  }
  .bot-loader {
    width: 35px;
    height: 35px;
  }
  .bot-loader::after {
    width: 35px;
    height: 35px;
  }
  .chat-icon:has(> .bot-icon) {
    position: sticky;
    top: 0;
    margin-bottom: 30px;
  }
  .answer-tags {
    padding: 8px 10px !important;
    font-size: 0.85rem;
  }
  ::ng-deep .formatted-table {
    font-size: 12px;
    margin: 10px 0;
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  ::ng-deep .formatted-table th,
  ::ng-deep .formatted-table td {
    padding: 8px 6px;
    font-size: 11px;
  }
  ::ng-deep .formatted-heading.h1 {
    font-size: 1.3em;
  }
  ::ng-deep .formatted-heading.h2 {
    font-size: 1.2em;
  }
  ::ng-deep .formatted-heading.h3 {
    font-size: 1.1em;
  }
  .button {
    min-height: 44px;
    min-width: 44px;
    touch-action: manipulation;
  }
  .comment-form > .button {
    margin-right: 5px !important;
    margin-bottom: 5px;
  }
  textarea.textarea {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
    appearance: none;
  }
  .fa, .fa-solid, .pi {
    font-size: 1rem !important;
  }
  .answer-header .fa,
  .answer-header .fa-solid,
  .answer-header .pi {
    font-size: 1.1rem !important;
  }
  .modal-footer input.input {
    width: 100%;
    box-sizing: border-box;
    font-size: 0.9rem;
    padding: 10px;
  }
  body {
    overflow-x: hidden;
  }
  #chat-tools {
    width: 50px;
    gap: 15px;
    right: 5px;
  }
  ::ng-deep .ql-container {
    height: 50vh !important;
  }
  ::ng-deep .ql-toolbar.ql-snow {
    padding: 5px;
    font-size: 0.85rem;
  }
  hr {
    margin: 10px 0 !important;
  }
  button[style*=margin-right] {
    margin-right: 5px !important;
  }
  div[style*="width:100%"] {
    height: 40px !important;
  }
  span[style*="text-align:justify"],
  span[style*="text-align: justify"] {
    display: block;
    text-align: left !important;
    padding: 5px 0;
  }
}
@media screen and (min-width: 641px) and (max-width: 768px) {
  #chat-list-content {
    width: 95% !important;
    padding: 0% 2.5% !important;
  }
  #chat-message-enter-box {
    width: 95% !important;
  }
  .question {
    padding: 14px 12px;
    font-size: 0.95rem;
  }
  .answer-content {
    font-size: 0.9rem;
  }
  .modal-content {
    width: 85% !important;
  }
  .comment-form .form-btns {
    flex-direction: row;
    gap: 10px;
  }
  .comment-form .form-btns .button {
    flex: 1;
  }
}
@media screen and (max-width: 480px) {
  #chat-list-content {
    padding: 0% 1% !important;
  }
  .question {
    padding: 10px 8px !important;
    font-size: 0.85rem !important;
  }
  .answer {
    padding: 8px 6px !important;
  }
  .answer-content {
    font-size: 0.8rem !important;
  }
  .answer-header {
    gap: 5px;
    padding-right: 3px;
  }
  .menu-list ul {
    right: -5px;
    padding: 3px;
  }
  .menu-list ul li {
    margin: 3px 4px;
    font-size: 0.85rem;
  }
  .comment-form {
    margin-left: 3px;
  }
  .comment-form .button {
    padding: 6px 10px;
    font-size: 0.8rem;
    min-height: 40px;
  }
  .date-label {
    font-size: 0.75rem;
  }
  .source-label {
    font-size: 0.8rem !important;
  }
}
.p-editor-container .p-editor-toolbar.ql-snow {
  border: 1px solid #e2e8f0;
}

.ql-container {
  height: 60vh !important;
}

.ql-toolbar.ql-snow {
  border: 1px solid #ccc;
  box-sizing: border-box;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  padding: 8px;
}

.botAccessType {
  background-color: #333;
  color: #fff;
  padding: 3px 12px 3px 12px;
  width: 110px;
  max-width: 100%;
  /* width: 100%; */
  border-radius: 6px;
  font-weight: normal;
  text-align: center;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* semi-transparent black */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* make sure it's above other content */
}

.modal-header {
  justify-content: space-between;
  background: var(--primaryColor);
  color: #fff;
}
.modal-header .fa-solid, .modal-header .fa {
  color: #fff !important;
}

.modal-content {
  background: #fff;
  padding: 0px;
  width: 750px;
  border-radius: 8px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  position: relative;
  overflow-y: hidden;
}
.modal-content .modal-body {
  height: calc(100vh - 200px);
  overflow-y: auto;
}
.modal-content .modal-footer .row {
  width: 100%;
}
.modal-content .modal-footer button[type=button] {
  margin-left: 10px;
}

.modal-fullscreen .modal-content {
  width: 90%;
}
.modal-fullscreen ::ng-deep .ql-editor {
  height: 60vh !important;
}

.btn-primary {
  background-color: var(--primaryColor) !important;
}

.bot-loader-wrapper {
  position: relative;
  width: 30px;
  height: 40px;
  margin-right: 25px;
}
.bot-loader-wrapper .ai-diamond {
  position: absolute;
  display: block;
  top: 8px;
  left: 8px;
  background-image: url('aidiamond.svg');
  background-size: cover;
  height: 25px;
  width: 25px;
}

.bot-loader {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-block;
  border-top: 4px solid #1571b9;
  border-right: 4px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.bot-loader::after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
::ng-deep .formatted-table {
  border-collapse: collapse;
  width: 100%;
  margin: 20px 0;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-size: 14px;
}

::ng-deep .formatted-table th {
  background: linear-gradient(135deg, #34495e, #2c3e50);
  color: white;
  padding: 15px 12px;
  text-align: left;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
  border: none;
}

::ng-deep .formatted-table td {
  padding: 12px;
  border-bottom: 1px solid #ecf0f1;
  border-right: 1px solid #ecf0f1;
  vertical-align: top;
  transition: background-color 0.2s ease;
  color: var(--textsecondarycolor) !important;
}

::ng-deep .formatted-table tr:hover td {
  background-color: #f8f9fa;
}

::ng-deep .formatted-table tr:nth-child(even) td {
  background-color: #f5f5f5;
}

::ng-deep .formatted-table tr:last-child td {
  border-bottom: none;
}

::ng-deep .formatted-table td:last-child {
  border-right: none;
}

/* Heading Styles */
::ng-deep .formatted-heading {
  color: var(--textsecondarycolor);
  margin: 10px 0px 0px 0;
  font-weight: 600;
  position: relative;
}

::ng-deep .formatted-heading.h1 {
  font-size: 1.5em;
  padding-bottom: 10px;
}

::ng-deep .formatted-heading.h2 {
  font-size: 1.4em;
  padding-bottom: 8px;
}

::ng-deep .formatted-heading.h3 {
  font-size: 1.3em;
  color: #34495e;
}

::ng-deep .formatted-heading.h4 {
  font-size: 1.2em;
  color: #34495e;
}

::ng-deep .formatted-heading.h5 {
  font-size: 1.1em;
  color: #34495e;
}

::ng-deep .formatted-heading.h6 {
  font-size: 1em;
  color: #34495e;
  text-transform: uppercase;
  letter-spacing: 1px;
}

::ng-deep .formatted-paragraph, ::ng-deep .response-container p {
  color: var(--textsecondarycolor) !important;
}
::ng-deep .formatted-paragraph .formatted-strong, ::ng-deep .response-container p .formatted-strong {
  color: var(--textsecondarycolor) !important;
}

::ng-deep .formatted-list {
  counter-reset: headings;
}
::ng-deep .formatted-list .list-item:not(:last-child) {
  border: none !important;
}
::ng-deep .formatted-list .list-item > p {
  margin-left: 25px !important;
}

::ng-deep .formatted-list li::before {
  border-radius: 15px;
  color: #6b6b6b;
  display: block;
  float: left;
  font-size: 16px;
  font-weight: bold;
  height: 25px;
  line-height: 26px;
  margin-bottom: 0;
  margin-right: 5px;
  text-indent: 8px;
  width: 25px;
}

.custom-file-audio {
  background-image: url('file-audio-svg.svg');
  background-repeat: no-repeat;
  background-size: cover;
  width: 20px;
  height: 18px;
  display: inline-block;
}

@media screen and (min-width: 768px) and (max-width: 960px) {
  #chat-list-content {
    padding: 1% 3% 0% 1% !important;
  }
}
.question-text {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  display: flex;
  gap: 7px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ai-assist/bot/bot/bot.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAGA;EACE,6BAAA;AAAF;;AAIA;EACE,YAAA;AADF;;AAOA;;EAEE,UAAA;EACA,aAAA;EACA,6BAAA;AAJF;;AAQA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;AALF;;AASA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,gDAAA;AANF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;AATF;;AAaA;EACE,aAAA;AAVF;;AAcA;EACE,eAAA;AAXF;;AAeA;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;AAZF;;AAgBA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gDAAA;EACA,gCAAA;AAbF;;AAiBA;EACE,sBAAA;EACA,oCAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;AAdF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAfF;;AAmBA;EACE,YAAA;EACA,gBAAA;AAhBF;;AAoBA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAjBF;AAoBE;EACE,oBAAA;EACA,6BAAA;EACA,qBAAA;AAlBJ;AAqBI;EACE,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AAnBN;AAuBI;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;AArBN;;AA2BA;EACE,eAAA;EACA,iBAAA;EACA,mCAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA;;gBAAA;EAGA,4BAAA;EACA;oCAAA;AAvBF;;AA4BA;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;AAzBF;;AA+BA;EACE,aAAA;AA5BF;;AAgCA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EAUD;;;;;;;;;MAAA;AA7BD;AAsBE;EACE,aAAA;EACO,mBAAA;EACA,yBAAA;EACC,mBAAA;EACA,2CAAA;AApBZ;;AAuCA;EACE,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,YAAA;EACA,UAAA;EAGA,cAAA;AAtCF;AAuCE;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;AArCJ;AAyCE;EACE,sBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;AAvCJ;AA2CE;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AAzCJ;;AA8CA;;;;;;;;GAAA;AAWA;;EAEE,cAAA;EACA,eAAA;EACA,0BAAA;AA7CF;;AAiDA;;EAEE,uBAAA;AA9CF;;AAkDA;EACE,oCAAA;AA/CF;;AAiDA;EACE,aAAA;EACA,SAAA;AA9CF;;AAgDA;EACE,WAAA;EAGA,2BAAA;EACA,yBAAA;EAMA,yBAAA;EACE,kBAAA;EAIA,kBAAA;EACF,gBAAA;EACA,eAAA;EAEA,kBAAA;EAEA,8BAAA;EACA,iBAAA;EACA,kBAAA;EAIA,kBAAA;EACA,aAAA;EACA,mBAAA;EAGA,kCAAA;EACA,uDAAA;EACA,wDAAA;AA9DF;;AAkEA;;;;;;;;;;;;;;;GAAA;AAgBA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AA/DF;;AAmEA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,yDAAA;AAhEF;;AAsEA;EACE,gBAAA;AAnEF;;AAuEA;EAOE,yBAAA;EACA,gCAAA;EACA,gBAAA;EAEA,sBAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EAMA,kDAAA;AAhFF;AAkFG;EACC,kCAAA;EACA,2BAAA;EACA,YAAA;AAhFJ;;AAmFA;EACI,kBAAA;EAEA,iBAAA;AAjFJ;;AAsFE;EACE,kBAAA;AAnFJ;AAqFE;EACG,YAAA;EACA,sBAAA;AAnFL;AAqFE;EACE,iBAAA;AAnFJ;;AAwFA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EAGA,gBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AAvFF;AAwFE;EACE,iBAAA;AAtFJ;AA0FE;EACE,8CAAA;AAxFJ;;AA8FA;EACE,eAAA;AA3FF;;AA+FA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AA5FF;;AAgGA;EACE,kBAAA;AA7FF;AAiGE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,oCAAA;EACA,8BAAA;AA/FJ;AAkGI;EACE,gBAAA;EACA,qBAAA;EACA,eAAA;AAhGN;AAqGM;EACE,cAAA;AAnGR;AAyGE;EACE,cAAA;AAvGJ;AA2GE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AAzGJ;;AAkHA;EACE,sBAAA;AA/GF;;AAoHA;EACE,uBAAA;AAjHF;AAoHE;EACE,0BAAA;EACA,0BAAA;EACA,WAAA;EACA,iBAAA;AAlHJ;AAsHE;EACE,oCAAA;EACA,0BAAA;AApHJ;;AAyHA;;;;;;;;;;;;;GAAA;AAgBA;EACE,kBAAA;EAEA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAzHF;;AAmIA;EAEI,gBAAA;EACA,eAAA;AAjIJ;;AAsIE;EACE,mBAAA;EACA,kBAAA;AAnIJ;;AAuIA;EACI,gCAAA;AApIJ;;AAuIA;EACE,wBAAA;AApIF;;AA4IA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,sDAAA;AAzIF;;AA6IA;EACE,kBAAA;EAGA,WAAA;AA5IF;AAgJE;EACE,aAAA;AA9IJ;;AAmJA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;AAhJF;AAmJE;EACE,eAAA;AAjJJ;AAqJE;EACE,mBAAA;AAnJJ;;AAwJA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,0BAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;AArJF;;AA2JA;EACE,WAAA;EACA,eAAA;AAxJF;;AA8JA;EACE,UAAA;EACA,eAAA;EACA,iBAAA;AA3JF;;AAiKA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;AA9JF;AAiKE;EACE,gBAAA;EACA,aAAA;AA/JJ;AAmKE;EACE,2BAAA;EACA,yCAAA;EACA,yBAAA;AAjKJ;;AAwKA;EACE,UAAA;AArKF;;AAyKA,UAAA;AACA;EACE,gBAAA;AAtKF;;AA0KA,WAAA;AACA;EACE,gBAAA;AAvKF;;AA2KA,oBAAA;AACA;EACE,gBAAA;AAxKF;;AA4KA;EACE,aAAA;EACA,6BAAA;EACA,WAAA;AAzKF;AA4KE;EACE,kCAAA;EACA,uBAAA;AA1KJ;;AA+KA;EACE,uBAAA;AA5KF;AA+KE;EACE,aAAA;AA7KJ;AAiLE;EACE,UAAA;EACA,gBAAA;AA/KJ;AAoLI;EACE,uBAAA;AAlLN;AAsLI;EACE,WAAA;AApLN;;AA4LA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;AAzLF;AA4LE;EACE,qBAAA;EACA,WAAA;AA1LJ;;AA+LA;EACE,aAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AA5LF;AA+LE;EACE,0BAAA;AA7LJ;;AAkMA;EACE,wBAAA;AA/LF;;AAmMA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,qCAAA;EACA,+CAAA;EACA,qBAAA;EACA,yBAAA;EACA,8CAAA;AAhMF;;AAoMA;EAKE,aAAA;EACA,gBAAA;EACA,sBAAA;EAEA,UAAA;AAtMF;AAyME;EACE,kCAAA;EAAA,6BAAA;AAvMJ;AA2ME;EACE,YAAA;AAzMJ;AA6ME;EACE,WAAA;EACA,aAAA;EACA,eAAA;AA3MJ;AA8MI;EACE,yBAAA;EACA,2BAAA;EACA,sBAAA;AA5MN;AAgNI;EACE,oCAAA;EACA,4BAAA;EACA,iBAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,oCAAA;AA9MN;;AAwNA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;AArNF;;AAyNA;EACE,iBAAA;EACA,gBAAA;AAtNF;AAyNE;EACE,iBAAA;AAvNJ;AA2NE;EACE,kBAAA;AAzNJ;AA6NE;EACE,gBAAA;AA3NJ;AA8NI;EACE,YAAA;AA5NN;AAmOI;EACE,0CAAA;EACA,sBAAA;AAjON;AAoOM;EACE,sBAAA;AAlOR;AAuOI;EACE,0CAAA;EACA,sBAAA;AArON;AAwOM;EACE,sBAAA;AAtOR;AA0OE;EACG,0CAAA;EACC,sBAAA;AAxON;AA6OI;EACE,2BAAA;EACA,qCAAA;EACA,gDAAA;EACA,kBAAA;AA3ON;AA8OM;EACE,8BAAA;AA5OR;;AAmPA;EACE,gBAAA;EACA,MAAA;EACA,mBAAA;AAhPF;;AAsPA;EAEE;IACE,sBAAA;IACA,yBAAA;IACA,gBAAA;EApPF;EAuPA;IACE,sBAAA;EArPF;EAyPA;IACE,WAAA;IACA,gBAAA;EAvPF;EA2PA;IACE,6BAAA;IACA,4BAAA;IACA,iCAAA;IACA,kBAAA;IACA,gBAAA;EAzPF;EA4PA;IACE,iBAAA;IACA,qBAAA;IACA,yBAAA;EA1PF;EA8PA;IACE,4BAAA;IACA,gCAAA;IACA,kBAAA;EA5PF;EA+PA;IACE,6BAAA;IACA,gBAAA;IACA,gBAAA;IACA,qBAAA;IACA,yBAAA;EA7PF;EAiQA;IACE,yBAAA;IACA,kBAAA;IACA,QAAA;IACA,gBAAA;IACA,mBAAA;EA/PF;EAkQA;IACE,eAAA;EAhQF;EAkQE;IACE,YAAA;IACA,YAAA;IACA,qBAAA;EAhQJ;EAkQI;IACE,eAAA;IACA,iBAAA;EAhQN;EAqQA;IACE,eAAA;EAnQF;EAuQA;IACE,6BAAA;IACA,gBAAA;IACA,cAAA;EArQF;EAyQA;IACE,gBAAA;IACA,eAAA;EAvQF;EAyQE;IACE,iBAAA;IACA,kBAAA;EAvQJ;EA0QE;IACE,sBAAA;IACA,eAAA;IACA,kBAAA;IACA,YAAA;EAxQJ;EA2QE;IACE,eAAA;EAzQJ;EA2QI;IACE,aAAA;IACA,sBAAA;IACA,QAAA;IACA,WAAA;EAzQN;EA2QM;IACE,WAAA;IACA,SAAA;EAzQR;EAgRA;IACE,iBAAA;IACA,mBAAA;EA9QF;EAkRA;IACE,4BAAA;IACA,sBAAA;IACA,QAAA;EAhRF;EAoRA;IACE,qBAAA;IACA,yBAAA;IACA,YAAA;EAlRF;EAoRE;IACE,2BAAA;IACA,aAAA;EAlRJ;EAqRE;IACE,kBAAA;EAnRJ;EAqRI;IACE,sBAAA;IACA,SAAA;EAnRN;EAsRI;IACE,WAAA;IACA,aAAA;IACA,aAAA;EApRN;EAyRA;IACE,sBAAA;IACA,aAAA;IACA,SAAA;IACA,gBAAA;EAvRF;EA2RA;IACE,WAAA;IACA,YAAA;IACA,kBAAA;EAzRF;EA2RE;IACE,WAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;EAzRJ;EA6RA;IACE,WAAA;IACA,YAAA;EA3RF;EA8RA;IACE,WAAA;IACA,YAAA;EA5RF;EAgSA;IACE,gBAAA;IACA,MAAA;IACA,mBAAA;EA9RF;EAkSA;IACE,4BAAA;IACA,kBAAA;EAhSF;EAoSA;IACE,eAAA;IACA,cAAA;IACA,cAAA;IACA,gBAAA;IACA,iCAAA;EAlSF;EAqSA;;IAEE,gBAAA;IACA,eAAA;EAnSF;EAsSA;IACE,gBAAA;EApSF;EAuSA;IACE,gBAAA;EArSF;EAwSA;IACE,gBAAA;EAtSF;EA0SA;IACE,gBAAA;IACA,eAAA;IACA,0BAAA;EAxSF;EA4SA;IACE,4BAAA;IACA,kBAAA;EA1SF;EA8SA;IACE,sBAAA;IACA,0BAAA;IACA,sBAAA;IAGA,gBAAA;EA5SF;EAgTA;IACE,0BAAA;EA9SF;EAkTA;;;IAGE,4BAAA;EAhTF;EAoTA;IACE,WAAA;IACA,sBAAA;IACA,iBAAA;IACA,aAAA;EAlTF;EAsTA;IACE,kBAAA;EApTF;EAwTA;IACE,WAAA;IACA,SAAA;IACA,UAAA;EAtTF;EA0TA;IACE,uBAAA;EAxTF;EA2TA;IACE,YAAA;IACA,kBAAA;EAzTF;EA6TA;IACE,yBAAA;EA3TF;EA+TA;IACE,4BAAA;EA7TF;EAiUA;IACE,uBAAA;EA/TF;EAmUA;;IAEE,cAAA;IACA,2BAAA;IACA,cAAA;EAjUF;AACF;AAqUA;EACE;IACE,qBAAA;IACA,2BAAA;EAnUF;EAsUA;IACE,qBAAA;EApUF;EAuUA;IACE,kBAAA;IACA,kBAAA;EArUF;EAwUA;IACE,iBAAA;EAtUF;EAyUA;IACE,qBAAA;EAvUF;EA2UE;IACE,mBAAA;IACA,SAAA;EAzUJ;EA2UI;IACE,OAAA;EAzUN;AACF;AA+UA;EACE;IACE,yBAAA;EA7UF;EAgVA;IACE,4BAAA;IACA,6BAAA;EA9UF;EAiVA;IACE,2BAAA;EA/UF;EAkVA;IACE,4BAAA;EAhVF;EAmVA;IACE,QAAA;IACA,kBAAA;EAjVF;EAoVA;IACE,WAAA;IACA,YAAA;EAlVF;EAoVE;IACE,eAAA;IACA,kBAAA;EAlVJ;EAsVA;IACE,gBAAA;EApVF;EAsVE;IACE,iBAAA;IACA,iBAAA;IACA,gBAAA;EApVJ;EAwVA;IACE,kBAAA;EAtVF;EAyVA;IACE,4BAAA;EAvVF;AACF;AA2VA;EACE,yBAAA;AAzVF;;AA2VC;EACC,uBAAA;AAxVF;;AA2VA;EACE,sBAAA;EACA,sBAAA;EACA,yDAAA;EACA,YAAA;AAxVF;;AA4VA;EACE,sBAAA;EACA,WAAA;EACA,0BAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAzVF;;AA6VA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,uCAAA;AA1VF;;AA4VA;EACE,8BAAA;EACA,+BAAA;EACA,WAAA;AAzVF;AA0VE;EACE,sBAAA;AAxVJ;;AA2VA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;AAxVF;AAyVE;EACE,2BAAA;EACA,gBAAA;AAvVJ;AA4VI;EACE,WAAA;AA1VN;AA4VI;EACE,iBAAA;AA1VN;;AA+VG;EACC,UAAA;AA5VJ;AA8VE;EACE,uBAAA;AA5VJ;;AAiWA;EACE,gDAAA;AA9VF;;AAkWA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA/VF;AAgWE;EACE,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,sCAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AA9VJ;;AAiWA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,6BAAA;EACA,mCAAA;EACA,sBAAA;EACA,sCAAA;AA9VF;;AAoWA;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAjWF;;AAqWA;EACE;IACE,uBAAA;EAlWF;EAoWA;IACE,yBAAA;EAlWF;AACF;AAoWA;EACgB,yBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,eAAA;AAlWhB;;AAqWC;EACe,qDAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;AAlWhB;;AAqWA;EACgB,aAAA;EACA,gCAAA;EACA,+BAAA;EACA,mBAAA;EACA,sCAAA;EACA,2CAAA;AAlWhB;;AAqWA;EACgB,yBAAA;AAlWhB;;AAqWA;EACgB,yBAAA;AAlWhB;;AAqWA;EACgB,mBAAA;AAlWhB;;AAqWA;EACgB,kBAAA;AAlWhB;;AAqWY,mBAAA;AACZ;EACgB,gCAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AAlWhB;;AAqWA;EACgB,gBAAA;EAEA,oBAAA;AAnWhB;;AAsWA;EACgB,gBAAA;EAEA,mBAAA;AApWhB;;AAuWA;EACgB,gBAAA;EACA,cAAA;AApWhB;;AAuWA;EACgB,gBAAA;EACA,cAAA;AApWhB;;AAuWA;EACgB,gBAAA;EACA,cAAA;AApWhB;;AAuWA;EACgB,cAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;AApWhB;;AAsWA;EACE,2CAAA;AAnWF;AAoWE;EACE,2CAAA;AAlWJ;;AAuWA;EACG,uBAAA;AApWH;AAuWG;EACE,uBAAA;AArWL;AAuWI;EACG,4BAAA;AArWP;;AA0WA;EAEI,mBAAA;EACA,cAAA;EAIA,cAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AA3WJ;;AAkXA;EACE,2CAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AA/WF;;AAoXA;EACE;IACE,+BAAA;EAjXF;AACF;AAuXA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;AArXF","sourcesContent":[":host {\n  width: 100%;\n}\n\n\nbody::ng-deep {\n  overflow-y: hidden !important;\n}\n\n\n.chat-header {\n  height: 50px;\n\n\n}\n\n\n.chat-header,\n.chat-content {\n  width: 90%;\n  display: flex;\n  justify-content: space-evenly;\n}\n\n\n.wrapper {\n  display: flex;\n  height: 100%;\n  flex-direction: row;\n  justify-content: stretch;\n}\n\n\n.chat-sidebar {\n  max-width: 320px;\n  height: 100%;\n  background: #fff;\n  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 0px 2.6px;\n}\n\n\n\n\n.chatBotstyle {\n  display: flex;\n  flex-direction: row;\n  width: 100% !important;\n  height: 100%;\n}\n\n\n.hide {\n  display: none;\n}\n\n\n.fa {\n  cursor: pointer;\n}\n\n\n.chat-box-wrapper {\n  position: relative;\n  display: flexbox;\n  width: 90%;\n}\n\n\n.chat-left-content {\n  background: #fff;\n  min-width: 280px;\n  overflow-y: auto;\n  /* box-shadow:2px 0px 0px rgba(0, 0, 0, 0.21); */\n  /* box-shadow:3px 0px #e9e9e9; */\n}\n\n\n.chat-right-content {\n  /* margin-left:20px; */\n  /* width: clamp(300px,150vw,70vw); */\n  min-width: 70%;\n  width: 100%;\n  overflow-y: auto;\n  display: flex;\n  justify-content: space-evenly;\n}\n\n\n#title {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  justify-content: space-evenly;\n  margin: 10px 0px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n\n.chat-history-list {\n  height: 80vh;\n  overflow-y: auto;\n}\n\n\n.chat-history-list ul {\n  margin: 10px 0px;\n  padding: 0px 10px;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2rem;\n\n\n  & li {\n    display: inline-flex;\n    justify-content: space-evenly;\n    align-items: baseline;\n\n\n    & label:first-child {\n      display: inline-block;\n      background: #eee;\n      color: #666;\n      border-radius: 10px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      cursor: pointer;\n      font-size: .9rem;\n      min-height: 25px;\n      padding: 10px 10px;\n      margin-bottom: 10px;\n      width: 90%;\n    }\n\n\n    & label:last-child {\n      margin: 0% 3%;\n      display: inline-block;\n      width: 5%;\n      padding-left: 2%;\n    }\n  }\n}\n\n\n#chat-list-content {\n  position: fixed;\n  /* bottom:90px; */\n  /* width:clamp(300px,198vw,68vw); */\n  margin-top: 75px;\n  width: 60%;\n  padding: 0% 2%;\n  /* overflow-y: auto;\n    height: 100vh;\n    top: 70px; */\n  font-size: .9rem !important;\n  /*  display: flex;\n    justify-content: space-evenly; */\n}\n\n\n#chat-list {\n  position: relative;\n  overflow-y: auto;\n  width: 95%;\n  height: 80vh;\n  padding-right: 5px;\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n  /* Firefox */\n\n\n}\n\n\n#chat-list::-webkit-scrollbar {\n  display: none;\n}\n\n\n.chat-list-row {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  position: relative;\n  padding: 0px 0px;\n\n\n  .date-label{\n    display: flex;\n           flex-direction: row;\n           justify-content: flex-end;\n            margin-bottom:30px;\n            color: var(--textsecondarycolor) !important;\n  }\n /* .menu-list{\n    display: none;\n  }\n\n\n  &:hover,&:focus{\n    .menu-list{\n       display: block;\n    }\n  } */\n}\n\n\n\n\n\n\n#chat-message-enter-box {\n  /* position: fixed; */\n  background: #fff;\n  width: 60%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  align-items: center;\n  border-radius: 5px;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;\n  height: 51px;\n  z-index: 1;\n\n\n  /* top:65px; */\n  & form {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    width: 100%;\n  }\n\n\n  & textarea {\n    width: 100% !important;\n    border: none;\n    padding: 10px;\n    color: #666;\n    font-size: 1em;\n    resize: none;\n    height: 55px;\n  }\n\n\n  & span {\n    display: inline-block;\n    color: #666;\n    width: 100% !important;\n    padding: 10px;\n    color: #666;\n    font-size: 1em;\n    min-height: 55px;\n  }\n}\n\n\n/* .chat-header > span{\n    display: inline-block;\n        color: #666;\n        width: 90% !important;\n        padding: 10px;\n        color: #666;\n        font-size:1em;\n        min-height:100px;\n} */\n\n\n.fa-cloud,\n.fa-user-circle {\n  color: #9da0a3;\n  margin-top: 5px;\n  font-size: 30px !important;\n}\n\n\napp-toggle-icon::ng-deep .fa-microphone-slash,\n.fa-microphone-slash {\n  opacity: 0.5 !important;\n}\n\n\ntextarea::placeholder {\n  color: rgb(182, 182, 182) !important;\n}\n.question.loading{\n  display: flex;\n  gap:10px;\n}\n.question {\n  width: 100%;\n  // background:#6089ca;\n  //  background:var(--primaryColor);\n  /* background: #9da0a3;   */\n  /* background: #01488f; */\n  //  border-left:1px solid #dcdcdc;\n  // border-right:1px solid #dcdcdc;\n  // border-top:1px solid #dcdcdc;\n  // border-top-left-radius:5px;\n  // border-top-right-radius:5px;\n  background-color: #f0f2f5;\n    border-radius: 8px;\n    // margin-left: auto;\n    // width: fit-content;\n    // max-width:840px;\n    padding: 12px 16px;\n  min-height: 50px;\n  font-size:1rem;\n  // border-radius:5px;\n  padding: 15px 10px;\n  //background: #fff;\n  color: var(--textprimarycolor);\n  font-weight: bold;\n  margin-bottom:1px;\n  //margin-bottom:10px;\n  // width:fit-content;\n  // margin-left:15px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  // justify-content: end;\n // box-shadow: rgba(14, 63, 126, 0.06) 0px 0px 0px 1px, rgba(42, 51, 70, 0.03) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 2px 2px -1px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.03) 0px 5px 5px -2.5px, rgba(42, 51, 70, 0.03) 0px 10px 10px -5px, rgba(42, 51, 70, 0.03) 0px 24px 24px -8px;\n  /* box-shadow: 2px 2px 3px #000; */\n  /* box-shadow: rgba(25, 118, 210, 0.35) 0px 5px 15px; */\n  /* box-shadow: rgba(109, 129, 153, 0.35) 0px 5px 15px; */\n}\n\n\n/* .question::before{\n    content: \" \";\n    position: absolute;\n    width: 0;\n    height: 0;\n    left:-15px;\n    right:auto;\n    top:10px;\n    bottom: auto;\n    border:15px solid;\n    border-color:var(--primaryColor) transparent transparent transparent;\n\n\n\n\n} */\n.question.align-right {\n  /* background: #f2fcff; */\n  background: #9da0a3;\n  min-height: 50px;\n  border-radius: 5px;\n  padding: 10px;\n  color: #fff;\n  margin-bottom: 10px;\n  width: 100%;\n  margin-left: 50%;\n  margin-right: 15px;\n  position: relative;\n}\n\n\n.question.align-right::before {\n  content: \" \";\n  position: absolute;\n  width: 0;\n  height: 0;\n  left: auto;\n  right: -20px;\n  top: 0px;\n  bottom: auto;\n  border: 21px solid;\n  border-color: #848a92 transparent transparent transparent;\n\n\n}\n\n\nvideo {\n  margin: 10px 0px;\n}\n\n\n.answer {\n  // border-bottom-left-radius:5px;\n  // border-bottom-right-radius:5px;\n  // border-left:1px solid #dcdcdc;\n  // border-right:1px solid #dcdcdc;\n  // border-bottom:1px solid #dcdcdc;\n  // background: #fff;\n  background-color: #f8f8f8;\n  border-radius:0px 24px 0px 24px;\n  min-height: 50px;\n  // border-radius:5px;\n  padding:0px 10px 10px;\n  color:var(--textsecondarycolor) !important;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-top:.2rem;\n // box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f;\n  //box-shadow: rgba(14, 63, 126, 0.06) 0px 0px 0px 1px, rgba(42, 51, 70, 0.03) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 2px 2px -1px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.03) 0px 5px 5px -2.5px, rgba(42, 51, 70, 0.03) 0px 10px 10px -5px, rgba(42, 51, 70, 0.03) 0px 24px 24px -8px;\n  // margin-left:19px;\n  // box-shadow: 1px 0px 3px #5555556e;\n  //    border: 1px solid #c8c8c8;\n  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */\n  // box-shadow: rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px;\n   .button{\n    background: transparent !important;\n    box-shadow: none !important;\n    border: none;\n   }\n}\n.source-label{\n    font-size: 0.95rem;\n   // color: #111;\n    text-align: right;\n}\n.document-file-input{\n\n\n  label{\n    margin-right:10px;\n  }\n  input[type=\"text\"]{\n     height:2rem;\n     border:1px solid #ccc;\n  }\n  input[type=\"text\"]::placeholder{\n    padding-left:2px;\n  }\n}\n\n\n.answer-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  padding-right: 10px;\n  gap: 15px;\n  min-height: 30px;\n // padding-top:10px;\n // background: #fff;\n  position: sticky;\n  right:0px;\n  top:0px;\n  bottom:10px;\n  z-index:9;\n  margin-bottom: 15px;\n  span {\n    font-weight: bold;\n  }\n\n\n  .fa-thumb-tack.active{\n    color:var(--buttonbackgroundcolor) !important;\n  }\n\n}\n\n\n.audio {\n  cursor: pointer;\n}\n\n\nul li {\n  display: inline;\n  list-style: none;\n  margin: 5px 10px;\n  display: inline-block;\n  cursor: pointer;\n}\n\n\n.menu-list {\n  position: relative;\n\n\n\n  & ul {\n    position: absolute;\n    top:2px;\n    right:-15px;\n    width: max-content;\n    background: #fff !important;\n    border:1px solid #dcdcdc !important;\n    border-radius:1rem !important;\n\n\n    li {\n      margin:6px 10px;\n      display: inline-block;\n      cursor: pointer;\n    }\n\n\n    li:hover {\n      .fa {\n        color: #008cb3;\n      }\n    }\n  }\n\n\n  & ul.active {\n    display: block;\n  }\n\n\n  & label {\n    width: 20px;\n    display: flex;\n    justify-content: center;\n    cursor: pointer;\n  }\n\n\n\n\n}\n\n\n.dropdown-menu {\n  left: -55px !important;\n  // top:-100px !important;\n}\n\n\n.dropdown-item {\n  padding: 0px !important;\n\n\n  li {\n    margin: 5px 0px !important;\n    font-size: 12px !important;\n    width: 100%;\n    padding: 5px 10px;\n  }\n\n\n  li:hover {\n    background: var(--primarylightColor);\n    color: var(--primaryColor);\n  }\n}\n\n\n/*.answer-content::before{\n    content: \" \";\n    position: absolute;\n    width: 0;\n    height: 0;\n    left:-25px;\n    right:auto;\n    top:-25px;\n    bottom: auto;\n    border: 21px solid;\n    border-color: #fff transparent transparent transparent;\n\n\n} */\n\n\n.answer-content {\n  position: relative;\n  // margin-top:25px;\n  padding:3px 5px;\n  line-height: 1.6;\n  font-size: 0.95rem;\n\n\n\n  // font-family: sans-serif;\n\n\n}\n\n\n.answer-content::ng-deep  ul{\n    // list-style:disc outside;\n    margin-left: 2em;\n    margin-top: 1em;\n\n  }\n\n\n  .answer-content ::ng-deep .answer-tags{\n    text-align: justify;\n    padding:10px 20px;\n   }\n\n\n.answer-content ::ng-deep pre{\n    white-space:pre-wrap !important;\n\n   }\n.answer-content::ng-deep ol {\n  padding: 10px !important;\n}\n\n\n\n\n\n\n.feedback::before {\n  content: \" \";\n  position: absolute;\n  width: 0;\n  height: 0;\n  left: -25px;\n  right: auto;\n  top: 0px;\n  bottom: auto;\n  border: 21px solid;\n  border-color: #fff transparent transparent transparent;\n}\n\n\n.feedback {\n  position: relative;\n\n\n  color: #111;\n\n\n  // font-family: sans-serif;\n  & ol {\n    padding: 30px;\n  }\n}\n\n\n.chat-icon {\n  width: 35px;\n  height: 35px;\n  border-radius: 100%;\n  background: var(--primarylightColor);\n\n\n  .bot-icon {\n    margin-top: 5px;\n  }\n\n\n  img {\n    border-radius: 100%;\n  }\n}\n\n\n.username {\n  width: 36px;\n  height: 36px;\n  border-radius: 100%;\n  background: var(--primarylightColor);\n  color: var(--primaryColor);\n  vertical-align: middle;\n  text-align: center;\n  font-size: 22px;\n  margin-right: 5px;\n  display: inline-block;\n  text-transform: uppercase;\n\n\n}\n\n\n#chatForm {\n  width: 100%;\n  height: inherit;\n\n\n}\n\n\n#chatForm>span {\n  width: 90%;\n  height: inherit;\n  margin-left: 10px;\n\n\n}\n\n\n#expand-collapse {\n  position: relative;\n  margin-top: 25px;\n  height: 15px;\n\n\n  i {\n    background: #fff;\n    padding: 10px;\n  }\n\n\n  .fa {\n    font-size: 1.5em !important;\n    transform: rotate(180deg) translateX(0px);\n    transform-origin: 50% 20%;\n  }\n\n\n}\n\n\n::-webkit-scrollbar {\n  width: 3px;\n}\n\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #fff;\n}\n\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #fff;\n}\n\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #fff;\n}\n\n\n#chat-content-wrapper {\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n\n\n  header {\n    background: transparent !important;\n    padding: 5px !important;\n  }\n}\n\n\n.chat-history-list::ng-deep .tabs-container {\n  height: 80vh !important;\n\n\n  ul {\n    display: flex;\n  }\n\n\n  li {\n    width: 50%;\n    font-size: .9em;\n  }\n\n\n  app-tab {\n    .pane {\n      padding: 0px !important;\n    }\n\n\n    li {\n      width: 100%;\n    }\n  }\n}\n\n\n\n\n#voice-message {\n  width: 80% !important;\n  position: relative;\n  background: #fff;\n  margin-top: -50px;\n  margin-left: 10px;\n  padding-right: 10px;\n  height: 50px;\n\n\n  span {\n    display: inline-block;\n    color: #999;\n  }\n}\n\n\n#chat-tools {\n  display: flex;\n  list-style-type: none;\n  width: 60px;\n  flex-direction: row;\n  gap: 20px;\n  padding: 0px;\n  margin: 0px;\n  position: relative;\n  right: 10px;\n\n\n  .fa-paper-plane {\n    font-size: 17px !important;\n  }\n}\n\n\n[hidden] {\n  display: none !important;\n}\n\n\n.comment-area-box::after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: 1px;\n  left: 99%;\n  box-sizing: border-box;\n  border: 10px solid rgba(0, 0, 0, 0.5);\n  border-color: transparent transparent #fff #fff;\n  transform-origin: 0 0;\n  transform: rotate(135deg);\n  box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.35);\n}\n\n\n.comment-area-box {\n  // position: absolute;\n  // z-index: 999;\n  // top:40px;\n  // right:0px;\n  display: none;\n  background: #fff;\n  padding: 15px 10px 5px;\n  // box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;\n  width: 80%;\n\n\n  label {\n    width: fit-content !important;\n  }\n\n\n  textarea {\n    resize: none;\n  }\n\n\n  .form-btns {\n    width: 100%;\n    display: flex;\n    margin: 5px 0px;\n\n\n    .btn:first-child {\n      border: 1px solid #dbdbdb;\n      background: #fff !important;\n      color: #000 !important;\n    }\n\n\n    .btn {\n      --bs-btn-line-height: 1.2 !important;\n      font-size: .9rem !important;\n      padding: 5px 20px;\n      color: #fff;\n      background: var(--primaryColor);\n      margin-right: 15px;\n      border: none;\n      cursor: pointer;\n      font-family: \"Noto Sans\", sans-serif;\n    }\n  }\n\n\n\n\n}\n\n\n.comment-area-box.is-active {\n  display: flex;\n  margin-top: 10px;\n  align-items: center;\n}\n\n\n.comment-form {\n  margin-left: 10px;\n  margin-top: 10px;\n\n\n  label {\n    font-size: .9rem;\n  }\n\n\n  textarea {\n    margin-right: 25px;\n  }\n\n\n  .comments-field {\n    margin-top: 10px;\n\n\n    .form-btns {\n      float: right;\n    }\n  }\n\n\n  .button {\n\n    &:hover {\n      background: var(--primaryColor) !important;\n      color: #fff !important;\n\n\n      .fa,.fa-solid{\n        color: #fff !important;\n      }\n    }\n\n\n    &.selected {\n      background: var(--primaryColor) !important;\n      color: #fff !important;\n\n\n      i {\n        color: #fff !important;\n      }\n    }\n  }\n  .sbtn{\n     background: var(--primaryColor) !important;\n      color: #fff !important;\n  }\n\n\n  .form-btns {\n    .button.sbtn:first-child {\n      background: #fff !important;\n      color: var(--primaryColor) !important;\n      border: 1px solid var(--primaryColor) !important;\n      margin-right: 10px;\n\n\n      &:hover {\n        background: #f5f5f5 !important;\n      }\n    }\n  }\n}\n\n\n.chat-icon:has(> .bot-icon) {\n  position: sticky;\n  top: 0;\n  margin-bottom: 40px;\n}\n\n\n\n\n@media screen and (max-width:640px) {\n  // Chat list content\n  #chat-list-content {\n    width: 100% !important;\n    padding: 0% 2% !important;\n    margin-top: 60px;\n  }\n\n  #chat-message-enter-box {\n    width: 100% !important;\n  }\n\n  // Chat list row\n  .chat-list-row {\n    width: 100%;\n    padding: 0px 5px;\n  }\n\n  // Question styling\n  .question {\n    padding: 12px 10px !important;\n    font-size: 0.9rem !important;\n    border-radius: 20px 4px 20px 20px;\n    margin-bottom: 5px;\n    min-height: auto;\n  }\n\n  .bot-search-text {\n    font-size: 0.9rem;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n\n  // Answer styling\n  .answer {\n    padding: 10px 8px !important;\n    border-radius: 0px 20px 0px 20px;\n    margin-top: 0.1rem;\n  }\n\n  .answer-content {\n    font-size: 0.85rem !important;\n    padding: 3px 2px;\n    line-height: 1.5;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n\n  // Answer header and menu\n  .answer-header {\n    justify-content: flex-end;\n    padding-right: 5px;\n    gap: 8px;\n    min-height: 25px;\n    margin-bottom: 10px;\n  }\n\n  .menu-list {\n    margin-top: 5px;\n\n    & ul {\n      right: -10px;\n      padding: 5px;\n      border-radius: 0.8rem;\n\n      li {\n        margin: 4px 6px;\n        font-size: 0.9rem;\n      }\n    }\n  }\n\n  ul li {\n    margin: 3px 5px;\n  }\n\n  // Source label\n  .source-label {\n    font-size: 0.85rem !important;\n    text-align: left;\n    padding: 5px 0;\n  }\n\n  // Comment form\n  .comment-form {\n    margin-left: 5px;\n    margin-top: 8px;\n\n    .button {\n      padding: 8px 12px;\n      font-size: 0.85rem;\n    }\n\n    textarea {\n      width: 100% !important;\n      margin-right: 0;\n      font-size: 0.85rem;\n      padding: 8px;\n    }\n\n    .comments-field {\n      margin-top: 8px;\n\n      .form-btns {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        width: 100%;\n\n        .button {\n          width: 100%;\n          margin: 0;\n        }\n      }\n    }\n  }\n\n  // Date label\n  .date-label {\n    font-size: 0.8rem;\n    margin-bottom: 20px;\n  }\n\n  // Question text in multiple answers\n  .question-text {\n    font-size: 0.9rem !important;\n    flex-direction: column;\n    gap: 5px;\n  }\n\n  // Modal responsiveness\n  .modal-content {\n    width: 95% !important;\n    max-width: 95% !important;\n    margin: 10px;\n\n    .modal-body {\n      height: calc(100vh - 250px);\n      padding: 15px;\n    }\n\n    .modal-footer {\n      padding: 10px 15px;\n\n      .row {\n        flex-direction: column;\n        gap: 10px;\n      }\n\n      button[type=button] {\n        width: 100%;\n        margin: 5px 0;\n        padding: 10px;\n      }\n    }\n  }\n\n  .modal-fullscreen .modal-content {\n    width: 100% !important;\n    height: 100vh;\n    margin: 0;\n    border-radius: 0;\n  }\n\n  // Bot loader\n  .bot-loader-wrapper {\n    width: 25px;\n    height: 35px;\n    margin-right: 15px;\n\n    .ai-diamond {\n      width: 20px;\n      height: 20px;\n      top: 6px;\n      left: 6px;\n    }\n  }\n\n  .bot-loader {\n    width: 35px;\n    height: 35px;\n  }\n\n  .bot-loader::after {\n    width: 35px;\n    height: 35px;\n  }\n\n  // Chat icon\n  .chat-icon:has(> .bot-icon) {\n    position: sticky;\n    top: 0;\n    margin-bottom: 30px;\n  }\n\n  // Answer tags\n  .answer-tags {\n    padding: 8px 10px !important;\n    font-size: 0.85rem;\n  }\n\n  // Formatted content\n  ::ng-deep .formatted-table {\n    font-size: 12px;\n    margin: 10px 0;\n    display: block;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  ::ng-deep .formatted-table th,\n  ::ng-deep .formatted-table td {\n    padding: 8px 6px;\n    font-size: 11px;\n  }\n\n  ::ng-deep .formatted-heading.h1 {\n    font-size: 1.3em;\n  }\n\n  ::ng-deep .formatted-heading.h2 {\n    font-size: 1.2em;\n  }\n\n  ::ng-deep .formatted-heading.h3 {\n    font-size: 1.1em;\n  }\n\n  // Touch-friendly buttons\n  .button {\n    min-height: 44px; // iOS recommended touch target\n    min-width: 44px;\n    touch-action: manipulation;\n  }\n\n  // Feedback buttons spacing\n  .comment-form > .button {\n    margin-right: 5px !important;\n    margin-bottom: 5px;\n  }\n\n  // Textarea responsive\n  textarea.textarea {\n    width: 100% !important;\n    max-width: 100% !important;\n    box-sizing: border-box;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n  }\n\n  // Icon sizes for mobile\n  .fa, .fa-solid, .pi {\n    font-size: 1rem !important;\n  }\n\n  // Answer header icons\n  .answer-header .fa,\n  .answer-header .fa-solid,\n  .answer-header .pi {\n    font-size: 1.1rem !important;\n  }\n\n  // Modal input fields\n  .modal-footer input.input {\n    width: 100%;\n    box-sizing: border-box;\n    font-size: 0.9rem;\n    padding: 10px;\n  }\n\n  // Prevent horizontal scroll\n  body {\n    overflow-x: hidden;\n  }\n\n  // Chat tools\n  #chat-tools {\n    width: 50px;\n    gap: 15px;\n    right: 5px;\n  }\n\n  // Quill editor mobile\n  ::ng-deep .ql-container {\n    height: 50vh !important;\n  }\n\n  ::ng-deep .ql-toolbar.ql-snow {\n    padding: 5px;\n    font-size: 0.85rem;\n  }\n\n  // Better spacing for multiple answers\n  hr {\n    margin: 10px 0 !important;\n  }\n\n  // Override inline styles for mobile\n  button[style*=\"margin-right\"] {\n    margin-right: 5px !important;\n  }\n\n  // Spinner container\n  div[style*=\"width:100%\"] {\n    height: 40px !important;\n  }\n\n  // Text alignment for mobile\n  span[style*=\"text-align:justify\"],\n  span[style*=\"text-align: justify\"] {\n    display: block;\n    text-align: left !important;\n    padding: 5px 0;\n  }\n}\n\n// Tablet responsiveness\n@media screen and (min-width: 641px) and (max-width: 768px) {\n  #chat-list-content {\n    width: 95% !important;\n    padding: 0% 2.5% !important;\n  }\n\n  #chat-message-enter-box {\n    width: 95% !important;\n  }\n\n  .question {\n    padding: 14px 12px;\n    font-size: 0.95rem;\n  }\n\n  .answer-content {\n    font-size: 0.9rem;\n  }\n\n  .modal-content {\n    width: 85% !important;\n  }\n\n  .comment-form {\n    .form-btns {\n      flex-direction: row;\n      gap: 10px;\n\n      .button {\n        flex: 1;\n      }\n    }\n  }\n}\n\n// Small mobile devices (up to 480px)\n@media screen and (max-width: 480px) {\n  #chat-list-content {\n    padding: 0% 1% !important;\n  }\n\n  .question {\n    padding: 10px 8px !important;\n    font-size: 0.85rem !important;\n  }\n\n  .answer {\n    padding: 8px 6px !important;\n  }\n\n  .answer-content {\n    font-size: 0.8rem !important;\n  }\n\n  .answer-header {\n    gap: 5px;\n    padding-right: 3px;\n  }\n\n  .menu-list ul {\n    right: -5px;\n    padding: 3px;\n\n    li {\n      margin: 3px 4px;\n      font-size: 0.85rem;\n    }\n  }\n\n  .comment-form {\n    margin-left: 3px;\n\n    .button {\n      padding: 6px 10px;\n      font-size: 0.8rem;\n      min-height: 40px;\n    }\n  }\n\n  .date-label {\n    font-size: 0.75rem;\n  }\n\n  .source-label {\n    font-size: 0.8rem !important;\n  }\n}\n\n\n.p-editor-container .p-editor-toolbar.ql-snow {\n  border: 1px solid #e2e8f0;\n}\n .ql-container{\n  height:60vh !important;\n}\n\n.ql-toolbar.ql-snow {\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n  padding: 8px;\n}\n\n\n.botAccessType {\n  background-color: #333;\n  color: #fff;\n  padding: 3px 12px 3px 12px;\n  width: 110px;\n  max-width: 100%;\n  /* width: 100%; */\n  border-radius: 6px;\n  font-weight: normal;\n  text-align: center;\n}\n\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  /* semi-transparent black */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  /* make sure it's above other content */\n}\n.modal-header{\n  justify-content:space-between;\n  background:var(--primaryColor);\n  color:#fff;\n  .fa-solid,.fa{\n    color:#fff !important;\n  }\n}\n.modal-content {\n  background: #fff;\n  padding:0px;\n  width: 750px;\n  border-radius: 8px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);\n  position: relative;\n  overflow-y: hidden;\n  .modal-body{\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n  }\n\n\n  .modal-footer{\n    .row{\n      width:100%;\n    }\n    button[type=button]{\n      margin-left:10px;\n    }\n  }\n}\n.modal-fullscreen{\n   .modal-content{\n    width:90%;\n   }\n  ::ng-deep .ql-editor{\n    height:60vh !important;\n  }\n}\n\n\n.btn-primary{\n  background-color: var(--primaryColor) !important;\n}\n\n\n.bot-loader-wrapper{\n  position: relative;\n  width:30px;\n  height:40px;\n  margin-right:25px;\n  .ai-diamond{\n    position: absolute;\n    display: block;\n    top:8px;\n    left:8px;\n    background-image: url('../../../../../assets/images/aidiamond.svg');\n    background-size: cover;\n    height:25px;\n    width:25px;\n  }\n}\n.bot-loader {\n  width:40px;\n  height:40px;\n  border-radius: 50%;\n  display: inline-block;\n  border-top: 4px solid #1571b9;\n  border-right: 4px solid transparent;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n\n\n\n\n}\n.bot-loader::after {\n  content: '';\n  box-sizing: border-box;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width:40px;\n  height:40px;\n  border-radius: 50%;\n // border-bottom: 4px solid #1ddadd;\n  //border-left: 4px solid transparent;\n}\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n::ng-deep .formatted-table {\n                border-collapse: collapse;\n                width: 100%;\n                margin: 20px 0;\n                background: white;\n                border-radius: 8px;\n                overflow: hidden;\n                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n                font-size: 14px;\n            }\n\n ::ng-deep  .formatted-table th {\n                background: linear-gradient(135deg, #34495e, #2c3e50);\n                color: white;\n                padding: 15px 12px;\n                text-align: left;\n                font-weight: 600;\n                text-transform: uppercase;\n                font-size: 12px;\n                letter-spacing: 0.5px;\n                border: none;\n            }\n\n::ng-deep .formatted-table td {\n                padding: 12px;\n                border-bottom: 1px solid #ecf0f1;\n                border-right: 1px solid #ecf0f1;\n                vertical-align: top;\n                transition: background-color 0.2s ease;\n                color: var(--textsecondarycolor) !important;\n            }\n\n::ng-deep .formatted-table tr:hover td {\n                background-color: #f8f9fa;\n            }\n\n::ng-deep .formatted-table tr:nth-child(even) td {\n                background-color: #f5f5f5;\n            }\n\n::ng-deep .formatted-table tr:last-child td {\n                border-bottom: none;\n            }\n\n::ng-deep .formatted-table td:last-child {\n                border-right: none;\n            }\n\n            /* Heading Styles */\n::ng-deep .formatted-heading {\n                color: var(--textsecondarycolor);\n                margin:10px 0px 0px 0;\n                font-weight: 600;\n                position: relative;\n            }\n\n::ng-deep .formatted-heading.h1 {\n                font-size:1.5em;\n               // border-bottom: 2px solid #78c9ff;\n                padding-bottom: 10px;\n            }\n\n::ng-deep .formatted-heading.h2 {\n                font-size: 1.4em;\n               // border-bottom: 2px solid #78c9ff;\n                padding-bottom: 8px;\n            }\n\n::ng-deep .formatted-heading.h3 {\n                font-size: 1.3em;\n                color: #34495e;\n            }\n\n::ng-deep  .formatted-heading.h4 {\n                font-size: 1.2em;\n                color: #34495e;\n            }\n\n::ng-deep .formatted-heading.h5 {\n                font-size: 1.1em;\n                color: #34495e;\n            }\n\n::ng-deep .formatted-heading.h6 {\n                font-size: 1em;\n                color: #34495e;\n                text-transform: uppercase;\n                letter-spacing: 1px;\n            }\n::ng-deep .formatted-paragraph,::ng-deep .response-container p{\n  color:var(--textsecondarycolor) !important;\n  .formatted-strong{\n    color:var(--textsecondarycolor) !important;\n  }\n}\n\n\n::ng-deep .formatted-list{\n   counter-reset: headings;\n\n\n   .list-item:not(:last-child){\n     border: none !important;\n    }\n    .list-item > p{\n       margin-left:25px !important;\n    }\n}\n\n\n::ng-deep .formatted-list li::before{\n  // background: none repeat scroll 0 0 #8F8888;\n    border-radius: 15px;\n    color: #6b6b6b;\n    // counter-increment: headings;\n    // content: counter(headings, decimal) \".\";\n    // content: \"•\";\n    display: block;\n    float: left;\n    font-size: 16px;\n    font-weight: bold;\n    height: 25px;\n    line-height: 26px;\n    margin-bottom: 0;\n    margin-right: 5px;\n    text-indent: 8px;\n    width: 25px;\n\n\n\n}\n\n\n.custom-file-audio{\n  background-image: url('../../../../../assets/images/file-audio-svg.svg');\n  background-repeat: no-repeat;\n  background-size: cover;\n  width:20px;\n  height:18px;\n  display: inline-block;\n}\n\n\n\n@media screen and (min-width:768px) and (max-width:960px) {\n  #chat-list-content {\n    padding: 1% 3% 0% 1% !important;\n  }\n\n\n}\n\n\n.question-text{\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 10px;\n  display: flex;\n  gap: 7px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
